// this file is generated by update_shopify_store_data.py at 2026-05-26 20:29:01.093332
var courses = [
    {
        "course_id": "244197D3-27BB-F011-99A0-005056A78EAA",
        "course_version": 1,
        "name": "Introduction to Qualitative Research in Healthcare",
        "course_type": 1,
        "author_information": "Julie Barroso, PhD, ANP, FNAP, FAAN",
        "description": "This e-learning equips learners with foundational knowledge and skills to design, conduct, and evaluate qualitative research in healthcare and related fields. Participants will explore core concepts such as research paradigms, ontology, and epistemology, and learn how these underpin qualitative methodologies. Through interactive activities and practical examples, the course covers study design, data collection strategies, data analysis approaches, and methods for ensuring rigor and trustworthiness.\r\n\r\nBy the end of the program, learners will be able to select appropriate qualitative methods for specific research questions, apply ethical principles in qualitative inquiry, and interpret findings in a way that informs practice, policy, and future research.",
        "learning_objectives_html": "By the end of this course, participants will be able to:\r\n<ol>Describe the philosophical foundations of qualitative research, including ontology, epistemology, and research paradigms. </ol>\r\n    <ol>Select and justify an appropriate qualitative research design based on a specific research question or problem.</ol>\r\n        <ol>Develop a plan for data collection, analysis, and strategies to ensure rigor and trustworthiness in qualitative inquiry.</ol>\r\n            <ol>Create a draft qualitative research proposal that integrates design, methodology, ethical considerations, and rationale.\r\n            </ol>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Personal Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8AB37F7D-FED1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing: Introduction to Qualitative Research in Healthcare",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DEF19C84-FED1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Introduction to Qualitative Research in Healthcare",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Leadership Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 4 contact hours to participants who complete all sections and complete the post course survey.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 4.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];